export let ajaxPost = (url, params, callback) => {
  const xhr = new XMLHttpRequest();

  xhr.open('POST', url);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.onload = callback.bind(xhr);
  xhr.send(params);
}

const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;
const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
export let validators = {
  "email": (val) => {
    return emailRegex.test(val);
  },
  "not-empty": (val) => {
    return !!val && val.length > 0;
  },
  "phone": (val) => {
    return phoneRegex.test(val);
  }
}